import { LoginUserPagePrivWrapper$ } from '@/auth/authentication';
import { useObservable } from 'react-use';
import { LoginUserPagePrivWrapper } from './LoginUserPagePrivWrapper';

export const useLoginUserPagePriv = (): LoginUserPagePrivWrapper | null | undefined => {
  const loginUserPagePriv = useObservable(LoginUserPagePrivWrapper$);
  return loginUserPagePriv;
};
